import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=521ea516&scoped=true&"
import script from "./Schedule.vue?vue&type=script&lang=js&"
export * from "./Schedule.vue?vue&type=script&lang=js&"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=521ea516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ea516",
  null
  
)

export default component.exports